<template>
  <div class="nv-empty" :class="{ 'nv-empty--visible': visible }">
    <div class="nv-empty-icon"><i class="fa" :class="icon"></i></div>
    <p class="nv-empty-title">{{ title }}</p>
    <p v-if="hint" class="nv-empty-hint">{{ hint }}</p>
    <router-link v-if="actionTo" :to="actionTo" class="btn btn-primary btn-sm nv-empty-action">
      <i class="fa fa-plus"></i> {{ actionLabel }}
    </router-link>
  </div>
</template>

<script>
// Friendly "nothing here" panel for list pages, used in vue-good-table's emptystate slot.
// Tables render that slot before the first load finishes, so it waits a moment and stays hidden
// while the page's "Please wait" overlay is up, instead of flashing "No keywords found".
const SHOW_AFTER_MS = 400

export default {
  name: 'nv-empty-state',
  props: {
    title: { type: String, default: 'Nothing here yet' },
    hint: String,
    icon: { type: String, default: 'fa-inbox' },
    actionLabel: String,
    actionTo: [String, Object]
  },
  data () {
    return { visible: false }
  },
  mounted () {
    const startedAt = Date.now()
    this.timer = setInterval(() => {
      const loading = document.querySelector('.loading-container')
      this.visible = Date.now() - startedAt >= SHOW_AFTER_MS && !loading
    }, 150)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>

<style>
.nv-empty {
  padding: 40px 16px;
  text-align: center;
  opacity: 0;
  transition: opacity 0.2s ease;
}
.nv-empty--visible { opacity: 1; }
.nv-empty-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 14px;
  border-radius: 50%;
  background: #E6F5F4;
  color: #0D9488;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nv-empty-title {
  margin: 0 0 4px;
  color: #1E3A5F;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 16px;
  font-weight: 700;
}
.nv-empty-hint {
  margin: 0 auto;
  max-width: 420px;
  color: #5C6E8A;
  font-size: 14px;
  white-space: normal;
}
.nv-empty-action { margin-top: 16px; }
</style>



// WEBPACK FOOTER //
// NvEmptyState.vue?e4aab4d6